import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ProductSideViewTypes } from "@temp/components/ProductSideView/types";
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";
export var ProductSideViewsTabs = function ProductSideViewsTabs(_ref) {
  var view = _ref.view,
      setView = _ref.setView,
      product = _ref.product;
  var intl = useIntl();
  var isMinimalist = product && product.productType.name === "door-minimalist";
  var handleProductSideViewTypes = useCallback(function () {
    setView(ProductSideViewTypes.all);
  }, [setView]);
  var handleDistanceToWall = useCallback(function () {
    setView(ProductSideViewTypes.distance_to_the_wall);
  }, [setView]);
  var handleSpaceAbove = useCallback(function () {
    setView(ProductSideViewTypes.space_above);
  }, [setView]);
  var handleDoorHeight = useCallback(function () {
    setView(ProductSideViewTypes.door_height);
  }, [setView]);
  var handleTotalHeight = useCallback(function () {
    setView(ProductSideViewTypes.total_height);
  }, [setView]);
  return React.createElement(S.Wrapper, null, React.createElement(S.Button, {
    onClick: handleProductSideViewTypes,
    active: view === ProductSideViewTypes.all
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Show all",
    "id": "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.4147597655"
  }, "id", "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.4147597655")))), React.createElement(S.Button, {
    onClick: handleDistanceToWall,
    active: view === ProductSideViewTypes.distance_to_the_wall
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Distance to the wall",
    "id": "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.1293712833"
  }, "id", "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.1293712833")))), React.createElement(S.Button, {
    onClick: handleDoorHeight,
    active: view === ProductSideViewTypes.door_height
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Door height",
    "id": "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.4222495457"
  }, "id", "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.4222495457")))), !isMinimalist && React.createElement(S.Button, {
    onClick: handleSpaceAbove,
    active: view === ProductSideViewTypes.space_above
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Space above",
    "id": "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.2943304725"
  }, "id", "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.2943304725")))), !isMinimalist && React.createElement(S.Button, {
    onClick: handleTotalHeight,
    active: view === ProductSideViewTypes.total_height
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Total height",
    "id": "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.3004980174"
  }, "id", "@next.components.molecules.ProductSideViewsTabs.ProductSideViewsTabs.3004980174")))));
};